import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=12ab1a3b&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=12ab1a3b&prod&lang=stylus&scoped=true"
import style1 from "./orders.vue?vue&type=style&index=1&id=12ab1a3b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab1a3b",
  null
  
)

export default component.exports